import { cx } from 'cva';
import React from 'react';

function NekiLogo(props) {
  const {
    className,
    src = 'https://s3.amazonaws.com/my.neki.io.prod/assets/images/Neki-Logo.svg',
  } = props;
  return (
    <img src={src} className={cx('h-8 w-auto', className)} alt="neki logo" />
  );
}

export default NekiLogo;
